import { css } from "@emotion/react";

const GoodsInfo: React.FC = () => {
  return (
    <div css={mainStyle} id="goods">
      <div css={staffContentsWrapperStyle}>
        <div css={titleWrapp}>
          <div css={upperTitleWrapperStyle}>
            <div css={borderStyle}></div>
            <div css={titleStyle}>グッズ紹介</div>
            <div css={borderStyle}></div>
          </div>
        </div>
      </div>
      <div css={contentsWrapperStyle}>
        <div css={pamphletWrapperStyle}>
          <div css={pamphletTitleStyle}>【公式パンフレット】</div>
          <img
            src={
              process.env.REACT_APP_ASSET_BASE_PATH + "/img/goods-pamphlet.jpg"
            }
            css={pamphletImgStyle}
            alt="パンフレット"
          />
          <div css={pamphletTxtStyle}>
            商品名：「音楽朗読劇　アシガール」パンフレット
            <br />
            販売価格：税込2,200円
            <br />
            ページ数：24P／サイズ：B5
            <br />
            <br />
            【内容】
            <br />
            ・森本梢子先生 コメント
            <br />
            ・キャスト コメント
            <br />
            （本田望結／紺野彩夏／増田俊樹／深堀未来／草川拓弥
            <br />
            　峯田大夢／新祐樹／梅田修一朗／尾崎由香／中島 愛
            <br />
            　小市眞琴／熊谷健太郎／山下誠一郎／橘 龍丸）
            <br />
            ・スタッフ コメント
            <br />
            （脚本・演出：岡本貴也／音楽監督：土屋雄作）
            <br />
            ・紺野彩夏×深堀未来　インタビュー　他
            <br />
            <br />
            ※数量限定となります。
            <br />
            ※会場のみでの販売となります。通信販売等での事後物販の
            <br />
            　予定はございません。
            <br />
            ※お支払いは現金のみとなります。
          </div>
        </div>
      </div>
    </div>
  );
};

const primaryColor = "#DD6B74";

const mainStyle = css`
  width: 100%;
  background-color: ${primaryColor};
  color: #fff;
`;

const staffContentsWrapperStyle = css`
  display: flex;
  justify-content: center;
`;

const titleWrapp = css`
  width: 100%;
  max-width: 500px;
  padding: 20px 20px 0px;
`;

const upperTitleWrapperStyle = css`
  display: flex;
  align-items: center;
`;

const borderStyle = css`
  height: 1px;
  background-color: #fff;
  flex-grow: 1;
`;

const titleStyle = css`
  margin: 0 10px;
  font-size: 12pt;
  font-weight: 500;
`;

const contentsWrapperStyle = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const pamphletWrapperStyle = css`
  width: 300px;
  padding: 30px 0 40px;
  font-size: 12pt;
`;

const pamphletTitleStyle = css`
  padding-bottom: 10px;
  font-size: 14px;
  text-align: left;
`;

const pamphletImgStyle = css`
  width: 100%;
  height: auto;
`;

const pamphletTxtStyle = css`
  margin-top: 10px;
  font-size: 11px;
  white-space: pre-wrap;
  text-align: left;
`;

export default GoodsInfo;
